export const TEMPLATE_STATUSES = {
  LIVE: 'live',
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  DELETED: 'deleted',
};
